// extracted by mini-css-extract-plugin
module.exports = {"containerHome":"home_containerHome__1cY51"};